import reducer from "./reducers";

import * as hospitalsActions from "./actions";

export { hospitalsActions };

export default reducer;
